/* Gratta e scopri: la lamina argento sopra lo sconto si gratta con il mouse o il dito.
   Passata meta' si apre da sola. La manina mostra solo il gesto, non gratta. */
(function () {
  function lamina(box) {
    var cv = box.querySelector('canvas'), r = box.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
    if (!cv || !r.width) return;
    box.classList.remove('is-aperto');
    cv.width = r.width * dpr; cv.height = r.height * dpr;
    var c = cv.getContext('2d'); c.setTransform(dpr, 0, 0, dpr, 0, 0); c.globalCompositeOperation = 'source-over';
    var g = c.createLinearGradient(0, 0, r.width, r.height);
    g.addColorStop(0, '#f4f5f7'); g.addColorStop(.35, '#c9ccd2'); g.addColorStop(.55, '#eef0f3'); g.addColorStop(1, '#a9adb5');
    c.fillStyle = g; c.fillRect(0, 0, r.width, r.height);
    for (var i = 0; i < 380; i++) { c.fillStyle = 'rgba(255,255,255,' + (Math.random() * .5) + ')'; c.fillRect(Math.random() * r.width, Math.random() * r.height, 1.2, 1.2); }
    c.strokeStyle = 'rgba(0,0,0,.06)';
    for (var x = -r.height; x < r.width; x += 7) { c.beginPath(); c.moveTo(x, r.height); c.lineTo(x + r.height, 0); c.stroke(); }
    var font = getComputedStyle(box).fontFamily;
    c.fillStyle = '#3c4048'; c.textAlign = 'center'; c.textBaseline = 'middle';
    c.font = '700 12px ' + font; c.fillText(cv.getAttribute('data-riga-1') || '', r.width / 2, r.height / 2 - 8);
    c.font = '600 10.5px ' + font; c.fillText(cv.getAttribute('data-riga-2') || '', r.width / 2, r.height / 2 + 9);
    c.globalCompositeOperation = 'destination-out';
    var tocchi = 0;
    function colpo(e) {
      var b = cv.getBoundingClientRect();
      c.beginPath(); c.arc(e.clientX - b.left, e.clientY - b.top, 13, 0, Math.PI * 2); c.fill();
      if (++tocchi % 8 === 0) {
        var d = c.getImageData(0, 0, cv.width, cv.height).data, v = 0;
        for (var i = 3; i < d.length; i += 64) if (d[i] === 0) v++;
        if (v / (d.length / 64) > .45) box.classList.add('is-aperto');
      }
    }
    cv.onpointermove = function (e) { if (e.pointerType === 'mouse' || e.buttons) colpo(e); };
    cv.onpointerdown = function (e) { if (cv.setPointerCapture) cv.setPointerCapture(e.pointerId); colpo(e); };
    /* sulla scheda tattile si gratta senza far scorrere la pagina */
    cv.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
  }
  function avvia() {
    document.querySelectorAll('[data-ap-gratta]').forEach(function (s) {
      s.querySelectorAll('[data-ap-biglietto]').forEach(lamina);
      var m = s.querySelector('.ap-gr__mano');
      if (!m || !window.IntersectionObserver || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        setTimeout(function () { m.classList.add('is-via'); }, 500);
        io.disconnect();
      }, { threshold: .6 });
      io.observe(s.querySelector('.ap-gr__fila'));
    });
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(avvia); else window.addEventListener('load', avvia);
  document.addEventListener('shopify:section:load', avvia);
})();
